import * as React from "react";

import type { VariantProps } from "class-variance-authority";

import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cva } from "class-variance-authority";

import { cn } from "../../utils";

const getInitial = (value: string) => value.charAt(0).toUpperCase();

export const getUserInitials = (firstName: string, lastName: string) =>
  `${getInitial(firstName)}${getInitial(lastName)}`;

const avatarVariants = cva(
  "af-relative af-flex af-shrink-0 af-overflow-hidden af-rounded-full af-border af-border-white",
  {
    variants: {
      size: {
        default: "af-size-10",
        md: "af-size-8",
        sm: "af-size-6",
        xs: "af-size-4",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);

function Avatar({
  className,
  size,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Root> &
  VariantProps<typeof avatarVariants>) {
  return (
    <AvatarPrimitive.Root
      className={cn(avatarVariants({ size }), className)}
      {...props}
    />
  );
}
Avatar.displayName = AvatarPrimitive.Root.displayName;

function AvatarImage({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Image>) {
  return (
    <AvatarPrimitive.Image
      data-slot="avatar-image"
      className={cn("af-aspect-square af-h-full af-w-full", className)}
      {...props}
    />
  );
}
AvatarImage.displayName = AvatarPrimitive.Image.displayName;

function AvatarFallback({
  className,
  ...props
}: React.ComponentProps<typeof AvatarPrimitive.Fallback>) {
  return (
    <AvatarPrimitive.Fallback
      data-slot="avatar-fallback"
      className={cn(
        "af-flex af-h-full af-w-full af-items-center af-justify-center af-rounded-full af-bg-muted af-text-xs af-font-semibold",
        className,
      )}
      {...props}
    />
  );
}
AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export { Avatar, AvatarImage, AvatarFallback };
